import { TileWebClient } from "../tiles.client";
import { WebTileUrlBuilder } from "../tiles.url.web";
import { Float32TileCodec, Float32TileCodecOptions, ImageTileCodec, RGBTileCodec } from "../codecs/tiles.codecs.image";
import { EPSG3857 } from "../geography/tiles.geography.EPSG3857";
import { DemTileWebClient } from "../../dem/dem.tileclient";
import { isFilter } from "../codecs/tiles.codecs.interfaces";
import { Cartesian4 } from "../../geometry";
import { Cartesian4TileCodec } from "../codecs/tiles.codecs.cartesian";
export class MapZenDemUrlBuilder extends WebTileUrlBuilder {
    constructor(format, extension = "png") {
        super();
        this.withHost("s3.amazonaws.com").withPath(`elevation-tiles-prod/${format}/{z}/{x}/{y}.{extension}`).withSecure(true).withExtension(extension);
    }
}
MapZenDemUrlBuilder.Terrarium = new MapZenDemUrlBuilder("terrarium");
MapZenDemUrlBuilder.Normal = new MapZenDemUrlBuilder("normal");
export class MapzenAltitudeDecoder {
    decode(pixels, offset, target, targetOffset) {
        const r = pixels[offset++];
        const g = pixels[offset++];
        const b = pixels[offset];
        target[targetOffset++] = r * 256 + g + b / 256 - 32768;
        return targetOffset;
    }
}
MapzenAltitudeDecoder.Shared = new MapzenAltitudeDecoder();
export class MapZenNormalsDecoder {
    decode(pixels, offset, target, targetOffset) {
        let v = target[targetOffset];
        if (!v) {
            v = target[targetOffset] = Cartesian4.Zero();
        }
        v.x = pixels[offset++];
        v.y = pixels[offset++];
        v.z = pixels[offset++];
        v.w = pixels[offset];
        return targetOffset + 1;
    }
}
MapZenNormalsDecoder.Shared = new MapZenNormalsDecoder();
export class MapZen {
    static ElevationsImagesClient(options) {
        return new TileWebClient(`${MapZen.KEY}_terrarium`, MapZenDemUrlBuilder.Terrarium, new ImageTileCodec(), MapZen.Metrics, options);
    }
    static ElevationsClient(options) {
        const o = isFilter(options?.filter) ? new Float32TileCodecOptions({ filter: options?.filter }) : undefined;
        return new TileWebClient(`${MapZen.KEY}_terrarium_float`, MapZenDemUrlBuilder.Terrarium, new Float32TileCodec(MapzenAltitudeDecoder.Shared, o), MapZen.Metrics, options);
    }
    static NormalsImagesClient(options) {
        return new TileWebClient(`${MapZen.KEY}_normal`, MapZenDemUrlBuilder.Normal, new ImageTileCodec(), MapZen.Metrics, options);
    }
    static NormalsUint8ArrayClient(options) {
        return new TileWebClient(`${MapZen.KEY}_normal`, MapZenDemUrlBuilder.Normal, new RGBTileCodec(), MapZen.Metrics, options);
    }
    static NormalsCartesian4Client(options) {
        return new TileWebClient(`${MapZen.KEY}_normal_Cartesian4`, MapZenDemUrlBuilder.Normal, new Cartesian4TileCodec(MapZenNormalsDecoder.Shared), MapZen.Metrics, options);
    }
    static DemClient(optionsElevations, optionsNormals) {
        return new DemTileWebClient(`${MapZen.KEY}_dem`, MapZen.ElevationsClient(optionsElevations), MapZen.NormalsUint8ArrayClient(optionsNormals));
    }
}
MapZen.KEY = "mapzen";
MapZen.MaxLevelOfDetail = 15;
MapZen.Metrics = new EPSG3857({ maxLOD: MapZen.MaxLevelOfDetail });
MapZen.Attribution = "Freely provided by MapZen - with thanks.";
//# sourceMappingURL=tiles.vendors.mapzen.js.map